import script from "./Mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./Mobile.vue?vue&type=script&setup=true&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=c7a52f54&lang=less&scoped=true"

import exportComponent from "D:\\MyProject\\jjlg-web-main-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a52f54"]])

export default __exports__